function el(type, classNames, attrs) {
    const elem = document.createElement(type);

    if (classNames) {
        classNames
            .split(' ')
            .forEach(className => elem.classList.add(className));
    }

    if (attrs) {
        Object.keys(attrs).forEach(key => elem.setAttribute(key, attrs[key]));
    }

    return elem;
}

function createWrapper() {
    const wrapper = el('div', null, { 'data-toast-wrapper': '' });
    const nav = document.querySelector('nav');
    const top = nav ? `${nav.offsetHeight}px` : 0;
    Object.assign(wrapper.style, {
        position: 'fixed',
        zIndex: 3,
        top,
        left: 0,
        right: 0,
    });
    return wrapper;
}

function createToast({ level, node }) {
    const toastEl = el('div', `toast toast--${level}`);
    const containerEl = el('div', 'container');
    const pageEl = el('div', 'page');
    const modEl = el('div', 'mod');
    const innerEl = el('div', 'inner');
    const bdEl = el('div', 'bd');
    bdEl.appendChild(node);
    innerEl.appendChild(bdEl);
    modEl.appendChild(innerEl);
    pageEl.appendChild(modEl);
    containerEl.appendChild(pageEl);
    toastEl.appendChild(containerEl);
    return toastEl;
}

function appendToast({ level, node, timeout }) {
    const toast = createToast({ level, node });
    const wrapper = toastWrapperElem();

    wrapper.appendChild(toast);

    setTimeout(() => {
        wrapper.removeChild(toast);
    }, timeout);
}

function toastWrapperElem() {
    return document.querySelector('[data-toast-wrapper]');
}

export default (
    { level = 'success', message = '', node, timeout = 4000 } = {}
) => {
    const body = document.body;
    if (!body) {
        return;
    }

    if (!toastWrapperElem()) {
        body.appendChild(createWrapper());
    }

    if (!node) {
        node = el('p', 'u-mb0', { role: 'status' });
        node.innerHTML = message;
    }

    appendToast({ level, node, timeout });
};
